import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)`
  width: 100%;

  /* Same split as SSM: white page header over the canvas-coloured body. */
  html[data-theme='light'] & > .header-container {
    background: ${theme.colors.surfaceContainerBackground};
  }
`

export const Wrapper = styled(Box)`
  padding-left: ${theme.spacing.medium}px;
  padding-right: ${theme.spacing.medium}px;
`
